import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
const DATE_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT_BBVA = 'YYYY-MM-DD';

export const dateToday = () => moment();

// Dates format
export const dateToString = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val).format(format) : '';

export const stringToDate = (val, format = DATE_FORMAT_DEFAULT) => moment(val, format);

export const dateToISO = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_ISO) : '';

export const isoToDate = (val, format = DATE_FORMAT_ISO) =>
  val ? moment(val, format).format(DATE_FORMAT_DEFAULT) : '';

export const changeFormatFromBBVA = val =>
  moment(val, DATE_FORMAT_BBVA).format(DATE_FORMAT_DEFAULT);

export const isValidDate = val =>
  // eslint-disable-next-line no-underscore-dangle
  moment(val, DATE_FORMAT_DEFAULT, true)._isValid;
